/**
 * ChildAware Website
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type DomainCertificationType = 'TeacherRegistration' | 'WorkingWithChildrenCheck' | 'Degree' | 'Diploma' | 'Certificate' | 'FirstAid' | 'Cpr' | 'Anaphylaxis' | 'Other' | 'VaccinationCertificate' | 'PoliceCheck';

export const DomainCertificationType = {
    TeacherRegistration: 'TeacherRegistration' as DomainCertificationType,
    WorkingWithChildrenCheck: 'WorkingWithChildrenCheck' as DomainCertificationType,
    Degree: 'Degree' as DomainCertificationType,
    Diploma: 'Diploma' as DomainCertificationType,
    Certificate: 'Certificate' as DomainCertificationType,
    FirstAid: 'FirstAid' as DomainCertificationType,
    Cpr: 'Cpr' as DomainCertificationType,
    Anaphylaxis: 'Anaphylaxis' as DomainCertificationType,
    Other: 'Other' as DomainCertificationType,
    VaccinationCertificate: 'VaccinationCertificate' as DomainCertificationType,
    PoliceCheck: 'PoliceCheck' as DomainCertificationType
};